/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConnectApiV1SandboxGithubOauthConnectionsPostRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  connectRequest: components.ConnectRequest;
};

/** @internal */
export const ConnectApiV1SandboxGithubOauthConnectionsPostRequest$inboundSchema:
  z.ZodType<
    ConnectApiV1SandboxGithubOauthConnectionsPostRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    "X-On-Behalf-Of": z.string().optional(),
    ConnectRequest: components.ConnectRequest$inboundSchema,
  }).transform((v) => {
    return remap$(v, {
      "X-On-Behalf-Of": "xOnBehalfOf",
      "ConnectRequest": "connectRequest",
    });
  });
/** @internal */
export type ConnectApiV1SandboxGithubOauthConnectionsPostRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  ConnectRequest: components.ConnectRequest$Outbound;
};

/** @internal */
export const ConnectApiV1SandboxGithubOauthConnectionsPostRequest$outboundSchema:
  z.ZodType<
    ConnectApiV1SandboxGithubOauthConnectionsPostRequest$Outbound,
    z.ZodTypeDef,
    ConnectApiV1SandboxGithubOauthConnectionsPostRequest
  > = z.object({
    xOnBehalfOf: z.string().optional(),
    connectRequest: components.ConnectRequest$outboundSchema,
  }).transform((v) => {
    return remap$(v, {
      xOnBehalfOf: "X-On-Behalf-Of",
      connectRequest: "ConnectRequest",
    });
  });

export function connectApiV1SandboxGithubOauthConnectionsPostRequestToJSON(
  connectApiV1SandboxGithubOauthConnectionsPostRequest:
    ConnectApiV1SandboxGithubOauthConnectionsPostRequest,
): string {
  return JSON.stringify(
    ConnectApiV1SandboxGithubOauthConnectionsPostRequest$outboundSchema.parse(
      connectApiV1SandboxGithubOauthConnectionsPostRequest,
    ),
  );
}
export function connectApiV1SandboxGithubOauthConnectionsPostRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ConnectApiV1SandboxGithubOauthConnectionsPostRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ConnectApiV1SandboxGithubOauthConnectionsPostRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ConnectApiV1SandboxGithubOauthConnectionsPostRequest' from JSON`,
  );
}
